/* Sui Story — Embroidered headline engine.
   Each headline (snippets/embroidery-headline.liquid) is real text split into
   per-letter spans. We "stitch" the letters in left→right with a small overshoot
   while a gold thread hairline draws beneath each line and settles — so it reads
   as hand embroidery, not a loading bar. Robust: no SVG/getBBox/viewBox fitting. */
(function () {
  var S = (window.SuiStory = window.SuiStory || {});

  var CHAR_STAGGER = 0.04;   // ~40ms between letters
  var CHAR_DUR = 0.5;

  function revealStatic(el) {
    el.querySelectorAll('.embroidery__char').forEach(function (c) {
      c.style.opacity = '1';
      c.style.transform = 'none';
      c.style.filter = 'none';
    });
    el.classList.add('is-drawn');
  }

  S.drawEmbroidery = function (el) {
    if (!el || el.dataset.embroidered === 'true') return;
    el.dataset.embroidered = 'true';

    var lines = el.querySelectorAll('.embroidery__line');
    if (!lines.length) { el.classList.add('is-drawn'); return; }

    if (!window.gsap || S.reduceMotion()) { revealStatic(el); return; }

    var lineDelay = 0;
    lines.forEach(function (line) {
      var chars = line.querySelectorAll('.embroidery__char');
      var thread = line.querySelector('.embroidery__thread');
      if (!chars.length) return;
      var sweep = Math.max(chars.length * CHAR_STAGGER, 0.3);

      gsap.fromTo(chars,
        { opacity: 0, yPercent: 24, scale: 0.78, filter: 'blur(4px)' },
        {
          opacity: 1, yPercent: 0, scale: 1, filter: 'blur(0px)',
          duration: CHAR_DUR, ease: 'back.out(1.6)', stagger: CHAR_STAGGER,
          delay: lineDelay, overwrite: 'auto'
        }
      );

      // Thread is laid down beneath the line in time with the letters, then dissolves.
      if (thread) {
        gsap.timeline({ delay: lineDelay })
          .fromTo(thread, { scaleX: 0, opacity: 0.85 },
                          { scaleX: 1, duration: sweep, ease: 'power1.inOut' })
          .to(thread, { opacity: 0, duration: 0.55, ease: 'power2.out' }, '>-0.05');
      }

      lineDelay += sweep * 0.55; // overlap consecutive lines slightly
    });

    gsap.delayedCall(lineDelay + CHAR_DUR + 0.2, function () { el.classList.add('is-drawn'); });
  };
})();
